import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { fetchCarriers } from '../../../../actions/carrier/carrierList'
import { AppState } from '../../../../reducers'
import { CarrierListState } from '../../../../reducers/carrier/carrierList'
import { CircularProgress, Stack } from '@mui/material'
import Carriers from '..'
import { useHistory } from 'react-router-dom'

interface Props {
  carrierList: CarrierListState
}

const CarrierList: React.FC<Props> = ({ carrierList }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [reading, setReading] = useState<boolean>(true)
   
  useEffect(() => {
    dispatch(fetchCarriers(history.location.search))
    setReading(false)
  }, [dispatch, history.location.search])

  return (
    <>
      {!reading && !carrierList.isFetching &&
        <Stack style={{ height: 'calc(100% - var(--header-height)'}}>
          <Carriers
            rows={(carrierList.carriers || []).map(s => ({ data: s }))}
            loading={carrierList.isFetching}
            pagination={carrierList.pagination || undefined}
            onClickInfo={() => {}}
          />
        </Stack>
      }
      {(reading || carrierList.isFetching) &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  carrierList: state.carrierList
})

export default connect(mapStateToProps, null)(CarrierList)